import * as PopoverPrimitive from '@radix-ui/react-popover';
import { ReactNode } from 'react';

interface PopoverProps {
  align?: 'center' | 'start' | 'end';
  sideOffset?: number;
  children: ReactNode;
  content: ReactNode;
}

export function Popover({ align = 'center', sideOffset = 4, children, content }: PopoverProps) {
  return (
    <PopoverPrimitive.Root>
      <PopoverPrimitive.Trigger asChild>{children}</PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align={align}
          sideOffset={sideOffset}
          className="bg-base-white data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 px-sm py-xs border-transparent-dark-16 z-50 origin-(--radix-popover-content-transform-origin) rounded-md border shadow-xs outline-hidden"
        >
          {content}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
